/**
 * vuex 状态管理
 */
import Vue from 'vue'
import Vuex from 'vuex'
// import rest from '../rest'
// import submit from './modules/usedcar/submit'

Vue.use(Vuex)

const state = {
  loading: {
    status: false,
    text: '',
    time: 0
  },
  direction: 'forward',
  toast: {
    show: false,
    text: '',
    time: 1000
  },
  customized: null, // 网站定制
  isDOS: false,
  source: 'default', // 默认来源
  authPrefix: '/auth/weixin'
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations: {
    UPDATE_LOADING (state, loading) {
      state.loading = Object.assign({}, state.loading, loading)
    },
    UPDATE_DIRECTION (state, direction) {
      state.direction = direction
    },
    UPDATE_TOAST (state, toast) {
      state.toast = toast
    },
    UPDATE_SOURCE (state, source) {
      if (source) {
        state.source = source
      }
    }
  },
  actions: {
    UPDATE_TOAST ({commit}, toast) {
      let t = Object.assign({}, toast)
      commit('UPDATE_TOAST', t)
      let st = null
      clearTimeout(st)
      st = setTimeout(() => {
        toast.show = false
        t = Object.assign({}, toast)
        commit('UPDATE_TOAST', t)
      }, t.time)
    },
    UPDATE_LOADING ({commit}, loading) {
      commit('UPDATE_LOADING', loading)
      if (loading && loading.time) {
        let st = null
        clearTimeout(st)
        st = setTimeout(() => {
          loading.show = false
          commit('UPDATE_LOADING', loading)
        }, loading.time)
      }
    },
    UPDATE_SOURCE ({ commit }, source) {
      commit('UPDATE_SOURCE', source)
    }
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js